import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShoppingBag, Plus, Minus, Trash2, Bike } from 'lucide-react';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from './ui/sheet';
import { Button } from './ui/button';
import { useCart } from '../context/CartContext';

const CartDrawer = () => {
  const { items, isOpen, setIsOpen, increment, decrement, removeItem, restaurant, subtotal, deliveryFee, total } = useCart();
  const navigate = useNavigate();

  const goCheckout = () => {
    setIsOpen(false);
    navigate('/checkout');
  };

  return (
    <Sheet open={isOpen} onOpenChange={setIsOpen}>
      <SheetContent className="w-full sm:max-w-md flex flex-col p-0">
        <SheetHeader className="px-6 py-4 border-b border-border">
          <SheetTitle className="flex items-center gap-2 font-display">
            <ShoppingBag className="h-5 w-5 text-primary" /> Il tuo carrello
          </SheetTitle>
          {restaurant && <p className="text-sm text-muted-foreground text-left">da {restaurant.name}</p>}
        </SheetHeader>

        {items.length === 0 ? (
          <div className="flex flex-1 flex-col items-center justify-center text-center px-6">
            <div className="flex h-20 w-20 items-center justify-center rounded-full bg-secondary mb-4">
              <ShoppingBag className="h-9 w-9 text-muted-foreground" />
            </div>
            <p className="font-display font-semibold text-foreground">Il carrello è vuoto</p>
            <p className="text-sm text-muted-foreground mt-1">Aggiungi qualche piatto delizioso per iniziare.</p>
          </div>
        ) : (
          <>
            <div className="flex-1 overflow-y-auto px-6 py-4 space-y-4">
              {items.map((item) => (
                <div key={item.id} className="flex gap-3">
                  {item.image ? (
                    <img src={item.image} alt={item.name} className="h-16 w-16 rounded-xl object-cover" />
                  ) : (
                    <div className="h-16 w-16 rounded-xl bg-secondary flex items-center justify-center text-muted-foreground">
                      <ShoppingBag className="h-6 w-6" />
                    </div>
                  )}
                  <div className="flex-1">
                    <div className="flex justify-between gap-2">
                      <p className="font-semibold text-foreground text-sm leading-tight">{item.name}</p>
                      <button onClick={() => removeItem(item.id)} className="text-muted-foreground hover:text-destructive transition-colors">
                        <Trash2 className="h-4 w-4" />
                      </button>
                    </div>
                    <p className="text-sm font-bold text-primary mt-1">{item.price.toFixed(2)} €</p>
                    <div className="mt-2 flex items-center gap-3">
                      <button onClick={() => decrement(item.id)} className="flex h-7 w-7 items-center justify-center rounded-full border border-border hover:bg-secondary">
                        <Minus className="h-3.5 w-3.5" />
                      </button>
                      <span className="text-sm font-semibold w-4 text-center">{item.qty}</span>
                      <button onClick={() => increment(item.id)} className="flex h-7 w-7 items-center justify-center rounded-full border border-border hover:bg-secondary">
                        <Plus className="h-3.5 w-3.5" />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="border-t border-border px-6 py-4 space-y-3">
              <div className="flex justify-between text-sm text-muted-foreground">
                <span>Subtotale</span><span>{subtotal.toFixed(2)} €</span>
              </div>
              <div className="flex justify-between text-sm text-muted-foreground">
                <span className="flex items-center gap-1.5"><Bike className="h-4 w-4" /> Consegna</span>
                <span>{deliveryFee === 0 ? 'Gratis' : `${deliveryFee.toFixed(2)} €`}</span>
              </div>
              <div className="flex justify-between font-display font-bold text-lg text-foreground pt-1">
                <span>Totale</span><span>{total.toFixed(2)} €</span>
              </div>
              <Button onClick={goCheckout} size="lg" className="w-full bg-primary hover:bg-primary/90 text-primary-foreground font-semibold">
                Vai al checkout
              </Button>
            </div>
          </>
        )}
      </SheetContent>
    </Sheet>
  );
};

export default CartDrawer;
